module.exports = "<p>report-dash-report-company works!</p>\r\n"